import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { setMerchantIsRequired } from "../../Merchants";
import { validateNumOrPin } from "../thunk";

const Container = styled.div`
  flex: 2.5 1 0%;
`;

const Num = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
  border-bottom: 1px solid rgba(51, 67, 61, 0.1);
  &:focus-within {
    border-bottom: 1px solid #ac936a;
  }
`;

const Icon = styled.span`
  position: absolute;
  right: 0.5rem;
  color: ${({ active }) => (active ? "#c7a878" : "#1F2021")};
`;

const CardNumber = ({
  merchantSelectorFocus,
  defaultValue,
  onChange,
  hasMerchant,
  maxLength,
  validation,
}) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);

  const onFocus = () => {
    if (!hasMerchant) {
      dispatch(setMerchantIsRequired(true));
      merchantSelectorFocus();
    } else {
      setActive(true);
    }
  };

  return (
    <Container>
      <Num>
        <input
          type="text"
          defaultValue={defaultValue}
          onChange={(e) => {
            e.persist();

            const value = e.target.value.trim();
            const { error, msg } = validateNumOrPin(
              "Gift Card Number",
              value,
              validation,
              0,
              true
            );

            onChange(e.target.name, value, error, msg);
          }}
          onFocus={() => onFocus()}
          onBlur={() => setActive(false)}
          className="form-control"
          style={{ border: "none", paddingRight: "2rem" }}
          placeholder={"Gift Card Number"}
          size={maxLength}
          name="number"
        />

        <Icon active={active}>
          <svg
            width="16px"
            height="13px"
            viewBox="0 0 16 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="Flow"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
              opacity={`${active ? "1" : "0.300000012"}`}
            >
              <g
                id="icon"
                transform="translate(-626.000000, -618.000000)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <g id="Form" transform="translate(219.000000, 156.000000)">
                  <g id="Group-2" transform="translate(132.000000, 459.000000)">
                    <g id="Group-5" transform="translate(0.000000, 2.000000)">
                      <g
                        id="credit-card"
                        transform="translate(275.000000, 1.000000)"
                      >
                        <path
                          d="M0,9.75 C0,11.5449254 1.4326888,13 3.2,13 L12.8,13 C14.5673112,13 16,11.5449254 16,9.75 L16,5.95833333 L0,5.95833333 L0,9.75 Z M12.8,0 L3.2,0 C1.4326888,0 0,1.45507456 0,3.25 L16,3.25 C16,1.45507456 14.5673112,0 12.8,0 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </Icon>
      </Num>
    </Container>
  );
};

CardNumber.DefaultProps = {
  defaultValue: null,
  validation: "",
};

CardNumber.propTypes = {
  merchantSelectorFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hasMerchant: PropTypes.bool.isRequired,
  validation: PropTypes.string.isRequired,

  maxLength: PropTypes.number,
  defaultValue: PropTypes.string,
};

export { CardNumber };
